import contract from "./quizworldcontract.json";
export const ETHERQUIZWORLD_CONTRACT_ADDRESS = contract.CONTRACT_ADDRESS;
export const ETHERQUIZWORLD_CONTRACT_ABI = contract.CONTRACT_ABI;
